import { Routes } from "@/constants"; 
import { Translations } from "@/translations";

interface MenuItem {
  id: number;
  hasDropdown?: boolean;
  active?: boolean;
  title: string;
  pluseIncon?: boolean;
  link: string;
  submenus?: any[];
  pages?: boolean;
  isBtn?: boolean;
}

const mobile_menu_data: MenuItem[] = [
  {
    id: 1,
    hasDropdown: false,
    title: Translations.General.HOMEPAGE,
    link: Routes.HOMEPAGE,
  },
  {
    id: 2,
    hasDropdown: false,
    title: Translations.General.LearningTools,
    link: Routes.LEARNING_TOOLS,
  },
  {
    id: 3,
    hasDropdown: false,
    title: Translations.General.EducationDiscovery,
    link: Routes.Education_Public_List,
  },
  {
    id: 4,
    hasDropdown: false,
    title: Translations.General.Contact,
    link: Routes.CONTACT,
  },
  {
    id: 5,
    hasDropdown: false,
    title: Translations.General.GetStarted,
    link: Routes.SIGN_IN,
  },
];

export default mobile_menu_data;
